import React from "react";

function IndexComponentsHeader(props) {
    return (
        <div id={props.title} className="blue-index-header">{props.title}</div>
    )
}

export default IndexComponentsHeader;